import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  saGetShowFuturePages,
  saIsFuturePage,
  saIsMockOnlyPage,
  saIsRealTenantsMode,
  saIsRouteAllowedInMvp,
  saResolveLegacyRoute,
} from '../../components/mvp-config.jsx';
import { STORES } from '../../components/data.jsx';
import { loadSavedRoute } from '../navigation/legacy-route-state.js';
import { consumeSavedRouteOnce, TEZUS_ROUTE_STORAGE_KEY } from './legacy-saved-route-migration.js';

/**
 * `/` — one-time migrate tezus-route → canonical URL (replace), then remove the key.
 * Explicit URLs never consult tezus-route (see discardSavedRouteKey in the layout).
 */
export function RootRedirect() {
  const target = React.useMemo(() => {
    try {
      const result = consumeSavedRouteOnce({
        storageKey: TEZUS_ROUTE_STORAGE_KEY,
        getItem: (key) => localStorage.getItem(key),
        removeItem: (key) => localStorage.removeItem(key),
        findStoreById: (id) => (STORES || []).find((x) => x.id === id) || null,
        isRealTenantsMode: typeof saIsRealTenantsMode === 'function' ? saIsRealTenantsMode : undefined,
        isRouteAllowedInMvp: typeof saIsRouteAllowedInMvp === 'function' ? saIsRouteAllowedInMvp : undefined,
        isMockOnlyPage: typeof saIsMockOnlyPage === 'function' ? saIsMockOnlyPage : undefined,
        isFuturePage: typeof saIsFuturePage === 'function' ? saIsFuturePage : undefined,
        getShowFuturePages: typeof saGetShowFuturePages === 'function' ? saGetShowFuturePages : undefined,
        resolveLegacyRoute: typeof saResolveLegacyRoute === 'function' ? saResolveLegacyRoute : undefined,
        loadSavedRoute,
      });
      return result.pathname || '/dashboard';
    } catch (e) {
      return '/dashboard';
    }
  }, []);

  return <Navigate to={target || '/dashboard'} replace />;
}
